webpackJsonp([1],{

/***/ 137:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill__ = __webpack_require__(96);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_polyfill___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_polyfill__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App__ = __webpack_require__(375);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__store__ = __webpack_require__(156);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(155);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mp_navigation_vue__ = __webpack_require__(380);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_mp_navigation_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_mp_navigation_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mp_footer_vue__ = __webpack_require__(379);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_mp_footer_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_mp_footer_vue__);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.








__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('mp-navigation', __WEBPACK_IMPORTED_MODULE_5__components_mp_navigation_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('mp-footer', __WEBPACK_IMPORTED_MODULE_6__components_mp_footer_vue___default.a);
__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].config.productionTip = false;

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */]({
  el: '#app',
  store: __WEBPACK_IMPORTED_MODULE_3__store__["a" /* store */],
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: { App: __WEBPACK_IMPORTED_MODULE_2__App___default.a }
});

/***/ }),

/***/ 155:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(389);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cv__ = __webpack_require__(377);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_cv___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_cv__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_projects__ = __webpack_require__(381);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_projects___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_projects__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home__ = __webpack_require__(378);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_home___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_home__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_contact__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_contact___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_contact__);







__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/home',
    name: 'home',
    component: __WEBPACK_IMPORTED_MODULE_4__components_home___default.a
  }, {
    path: '/projects',
    name: 'projects',
    component: __WEBPACK_IMPORTED_MODULE_3__components_projects___default.a
  }, {
    path: '/cv',
    name: 'cv',
    component: __WEBPACK_IMPORTED_MODULE_2__components_cv___default.a
  }, {
    path: '/contact',
    name: 'contact',
    component: __WEBPACK_IMPORTED_MODULE_5__components_contact___default.a
  }, {
    path: '/',
    name: 'default',
    redirect: '/home'
  }]
}));

/***/ }),

/***/ 156:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return store; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(95);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuex__ = __webpack_require__(392);



__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */]);

var store = new __WEBPACK_IMPORTED_MODULE_1_vuex__["a" /* default */].Store({
  state: {
    activePage: 'none'
  }
});

/***/ }),

/***/ 157:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'app'
});

/***/ }),

/***/ 158:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'contact',
  data: function data() {
    return {
      contactData: {}
    };
  },
  mounted: function mounted() {
    this.$store.state.activePage = 'contact';
    var self = this;
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('static/json/contact-data.json').then(function (response) {
      self.contactData = response.data;
    });
  },

  methods: {}
});

/***/ }),

/***/ 159:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'cv',
  data: function data() {
    return {
      cvData: {}
    };
  },
  mounted: function mounted() {
    this.$store.state.activePage = 'cv';
    var self = this;
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('static/json/cv-data.json').then(function (response) {
      self.cvData = response.data;
    });
  },

  methods: {
    monthName: function monthName(value) {
      switch (value) {
        case 1:
          return 'Jan';
        case 2:
          return 'Feb';
        case 3:
          return 'Mar';
        case 4:
          return 'Apr';
        case 5:
          return 'May';
        case 6:
          return 'June';
        case 7:
          return 'July';
        case 8:
          return 'Aug';
        case 9:
          return 'Sept';
        case 10:
          return 'Oct';
        case 11:
          return 'Nov';
        case 12:
          return 'Dec';
        default:
          return '';
      }
    }
  }
});

/***/ }),

/***/ 160:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'home',
  data: function data() {
    return {
      homeData: {}
    };
  },
  mounted: function mounted() {
    this.$store.state.activePage = 'home';
    var self = this;
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('static/json/home-data.json').then(function (response) {
      self.homeData = response.data;
    });
  }
});

/***/ }),

/***/ 161:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
//
//
//
//
//
//
//
//
//
//
//
//
//


/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      footerData: {}
    };
  },
  mounted: function mounted() {
    var self = this;
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('static/json/footer-data.json').then(function (response) {
      self.footerData = response.data;
    });
  }
});

/***/ }),

/***/ 162:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  computed: {
    activePage: function activePage() {
      return this.$store.state.activePage;
    }
  },
  data: function data() {
    return {
      navigation: [{
        title: 'Home',
        page: 'home'
      }, {
        title: 'Projects',
        page: 'projects'
      }, {
        title: 'CV',
        page: 'cv'
      }, {
        title: 'Contact',
        page: 'contact'
      }],
      mobileNavOpen: false
    };
  }
});

/***/ }),

/***/ 163:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios__ = __webpack_require__(48);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_bootstrap_modal__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue2_bootstrap_modal___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue2_bootstrap_modal__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  name: 'projects',
  data: function data() {
    return {
      projectsData: {},
      projectDetails: {
        title: '',
        company: '',
        website: {},
        language: '',
        finished: false,
        description: '',
        sourceCode: {},
        images: ''
      }
    };
  },
  mounted: function mounted() {
    this.$store.state.activePage = 'projects';
    var self = this;
    __WEBPACK_IMPORTED_MODULE_0_axios___default.a.get('static/json/projects-data.json').then(function (response) {
      self.projectsData = response.data;
    });
  },

  methods: {
    showDetails: function showDetails(project) {
      this.projectDetails = project;
      this.$refs.projectDetails.open();
    }
  },
  components: {
    'bootstrap-modal': __WEBPACK_IMPORTED_MODULE_1_vue2_bootstrap_modal___default.a
  }
});

/***/ }),

/***/ 364:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 365:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 366:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 367:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 368:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 369:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 370:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 375:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(369)
}
var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(157),
  /* template */
  __webpack_require__(387),
  /* styles */
  injectStyle,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 376:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(368)
}
var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(158),
  /* template */
  __webpack_require__(386),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3ca54fd1",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 377:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(366)
}
var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(159),
  /* template */
  __webpack_require__(384),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3871b8d2",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 378:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(367)
}
var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(160),
  /* template */
  __webpack_require__(385),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-3b1a5504",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 379:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(365)
}
var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(161),
  /* template */
  __webpack_require__(383),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2f1953f6",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 380:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(364)
}
var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(162),
  /* template */
  __webpack_require__(382),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-2bcf6a6f",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 381:
/***/ (function(module, exports, __webpack_require__) {

function injectStyle (ssrContext) {
  __webpack_require__(370)
}
var Component = __webpack_require__(43)(
  /* script */
  __webpack_require__(163),
  /* template */
  __webpack_require__(388),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-47859819",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 382:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "navbar navbar-default"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "navbar-header"
  }, [_c('a', {
    staticClass: "navbar-brand",
    attrs: {
      "href": "#/"
    },
    on: {
      "click": function($event) {
        _vm.mobileNavOpen = false
      }
    }
  }, [_vm._v("Ricardo van der Heijden")]), _vm._v(" "), _c('a', {
    staticClass: "btn btn-default btn-lg mobile-nav-toggle",
    on: {
      "click": function($event) {
        _vm.mobileNavOpen = !_vm.mobileNavOpen
      }
    }
  }, [_c('span', {
    staticClass: "glyphicon",
    class: {
      'glyphicon-remove': _vm.mobileNavOpen, 'glyphicon-menu-hamburger': !_vm.mobileNavOpen
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "collapse navbar-collapse",
    class: { in: _vm.mobileNavOpen
    }
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, _vm._l((_vm.navigation), function(item) {
    return _c('li', {
      class: {
        active: _vm.activePage == item.page
      },
      on: {
        "click": function($event) {
          _vm.mobileNavOpen = false
        }
      }
    }, [_c('a', {
      attrs: {
        "href": '#/' + item.page
      }
    }, [_vm._v(_vm._s(item.title))])])
  }))]), _vm._v(" "), _c('div')])])
},staticRenderFns: []}

/***/ }),

/***/ 383:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row links col-xs-12"
  }, [_c('ul', [_vm._l((_vm.footerData.links), function(link) {
    return _c('li', [_c('a', {
      attrs: {
        "href": link.url,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(link.name))])])
  }), _vm._v(" "), _vm._m(0)], 2)])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#/contact"
    }
  }, [_vm._v("Contact")])])
}]}

/***/ }),

/***/ 384:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "cv"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "work-experience cv-section"
  }, [_c('h2', [_vm._v("Work Experience")]), _vm._v(" "), _vm._l((_vm.cvData.workExperience), function(work) {
    return _c('div', {
      staticClass: "container row"
    }, [_c('div', {
      staticClass: "row col-sm-1"
    }, [_c('img', {
      staticClass: "logo",
      attrs: {
        "src": work.logo
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "row col-sm-4 col-md-3"
    }, [_c('span', {
      staticClass: "col-xs-5 col-sm-12"
    }, [_c('strong', [_vm._v(_vm._s(work.company))])]), _vm._v(" "), _c('span', {
      staticClass: "col-xs-7 col-sm-12 work-title text-right"
    }, [_c('em', [_vm._v(_vm._s(work.title))])]), _vm._v(" "), _c('span', {
      staticClass: "col-xs-12"
    }, [_vm._v(_vm._s(_vm.monthName(work.startMonth)) + " " + _vm._s(work.startYear) + " - "), (work.endYear) ? _c('span', [_vm._v(_vm._s(_vm.monthName(work.endMonth)) + " " + _vm._s(work.endYear))]) : _c('span', [_vm._v("Present")])])]), _vm._v(" "), _c('div', {
      staticClass: "summary-line col-sm-7 col-md-8"
    }, [_c('ul', _vm._l((work.summary), function(summaryLine) {
      return _c('li', [_vm._v(_vm._s(summaryLine))])
    }))]), _vm._v(" "), _c('div', {
      staticClass: "projects"
    }, _vm._l((work.projects), function(project) {
      return _c('div', {
        staticClass: "row col-sm-12"
      }, [_c('div', {
        staticClass: "row col-sm-1"
      }, [_c('img', {
        staticClass: "logo",
        attrs: {
          "src": project.logo
        }
      })]), _vm._v(" "), _c('div', {
        staticClass: "row col-sm-4 col-md-3"
      }, [_c('span', {
        staticClass: "col-xs-5 col-sm-12"
      }, [_c('strong', [_vm._v(_vm._s(project.company))])]), _vm._v(" "), _c('span', {
        staticClass: "col-xs-7 col-sm-12 work-title text-right"
      }, [_c('em', [_vm._v(_vm._s(project.title))])]), _vm._v(" "), _c('span', {
        staticClass: "col-xs-12"
      }, [_vm._v(_vm._s(_vm.monthName(project.startMonth)) + " " + _vm._s(project.startYear) + " - "), (project.endYear) ? _c('span', [_vm._v(_vm._s(_vm.monthName(project.endMonth)) + " " + _vm._s(project.endYear))]) : _c('span', [_vm._v("Present")])])]), _vm._v(" "), _c('div', {
        staticClass: "summary-line col-sm-7 col-md-8"
      }, [_c('ul', _vm._l((project.summary), function(summaryLine) {
        return _c('li', [_vm._v(_vm._s(summaryLine))])
      }))])])
    }))])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "education cv-section"
  }, [_c('h2', [_vm._v("Education")]), _vm._v(" "), _vm._l((_vm.cvData.education), function(education) {
    return _c('div', {
      staticClass: "container row"
    }, [_c('div', {
      staticClass: "row col-sm-1"
    }, [_c('img', {
      staticClass: "logo",
      attrs: {
        "src": education.logo
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-11"
    }, [_c('strong', [(education.degree) ? _c('span', [_vm._v(_vm._s(education.degree) + " ")]) : _vm._e(), _vm._v(" "), (education.fieldOfStudy) ? _c('span', [_vm._v(_vm._s(education.fieldOfStudy) + ", ")]) : _vm._e(), _vm._v(" "), (education.school) ? _c('span') : _vm._e(), _vm._v(_vm._s(education.school) + "\n          ")]), _vm._v(" "), _c('br'), _vm._v(" "), (education.city) ? _c('span', [_vm._v(_vm._s(education.city) + ", ")]) : _vm._e(), _vm._v("\n          " + _vm._s(education.country) + " -\n          " + _vm._s(education.startYear) + "-"), (education.endYear) ? _c('span', [_vm._v(_vm._s(education.endYear))]) : _c('span', [_vm._v("Present")])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "certifications-skills cv-section"
  }, [_c('h2', [_vm._v("Certifications & Skills")]), _vm._v(" "), _c('div', {
    staticClass: "container row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('ul', _vm._l((_vm.cvData.certificationsSkills.programming), function(skill) {
    return _c('li', [_vm._v(_vm._s(skill))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "container row"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('ul', _vm._l((_vm.cvData.certificationsSkills.tools), function(skill) {
    return _c('li', [_vm._v(_vm._s(skill))])
  }))])]), _vm._v(" "), _c('div', {
    staticClass: "container row"
  }, [_vm._m(3), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('ul', _vm._l((_vm.cvData.certificationsSkills.soft), function(skill) {
    return _c('li', [_vm._v(_vm._s(skill))])
  }))])])]), _vm._v(" "), _c('div', {
    staticClass: "interests-hobbies cv-section"
  }, [_c('h2', [_vm._v("Interests & Hobbies")]), _vm._v(" "), _c('div', {
    staticClass: "container row"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('ul', _vm._l((_vm.cvData.interestsHobbies), function(interest) {
    return _c('li', [_vm._v(_vm._s(interest))])
  }))])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("Curriculum Vitae")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container type"
  }, [_c('strong', [_vm._v("Programming skills")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container type"
  }, [_c('strong', [_vm._v("Tooling skills")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container type"
  }, [_c('strong', [_vm._v("Soft skills")])])
}]}

/***/ }),

/***/ 385:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "home row row-eq-height"
  }, [_c('div', {
    staticClass: "col-sm-4 image"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.homeData.image
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8 introduction"
  }, [_c('h1', [_vm._v(_vm._s(_vm.homeData.title))]), _vm._v(" "), _vm._l((_vm.homeData.introduction), function(paragraph) {
    return _c('p', [_vm._v(_vm._s(paragraph))])
  })], 2)])])
},staticRenderFns: []}

/***/ }),

/***/ 386:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact"
  }, [_c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v(_vm._s(_vm.contactData.title))])])]), _vm._v(" "), _c('div', {
    staticClass: "contact-section"
  }, _vm._l((_vm.contactData.contacts), function(contact) {
    return _c('div', {
      staticClass: "contact-item"
    }, [_c('h3', [_c('img', {
      staticClass: "logo",
      attrs: {
        "src": contact.logo
      }
    }), _vm._v(" "), _c('a', {
      attrs: {
        "href": contact.link,
        "target": "_blank"
      }
    }, [_vm._v(_vm._s(contact.text))])]), _vm._v(" "), _c('div', [_c('img', {
      staticClass: "qr",
      attrs: {
        "src": contact.qr
      }
    })])])
  }))])
},staticRenderFns: []}

/***/ }),

/***/ 387:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('mp-navigation'), _vm._v(" "), _c('router-view', {
    staticClass: "view"
  }), _vm._v(" "), _c('mp-footer')], 1)
},staticRenderFns: []}

/***/ }),

/***/ 388:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "projects"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "professional project-section container row"
  }, [_c('h2', [_vm._v("Professional")]), _vm._v(" "), _vm._l((_vm.projectsData.professional), function(project) {
    return _c('div', [_c('div', {
      staticClass: "col-sm-4 project",
      on: {
        "click": function($event) {
          _vm.showDetails(project)
        }
      }
    }, [_c('img', {
      staticClass: "logo",
      attrs: {
        "src": project.images[0]
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "row col-sm-11"
    }, [_c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', [_vm._v(_vm._s(project.name))]), _vm._v(" "), _c('li', [_c('em', [_vm._v(_vm._s(project.company))])])])])])])
  })], 2), _vm._v(" "), _c('div', {
    staticClass: "side project-section container row"
  }, [_c('h2', [_vm._v("Others")]), _vm._v(" "), _vm._l((_vm.projectsData.others), function(project) {
    return _c('div', [_c('div', {
      staticClass: "col-sm-4 project",
      on: {
        "click": function($event) {
          _vm.showDetails(project)
        }
      }
    }, [_c('img', {
      staticClass: "logo",
      attrs: {
        "src": project.images[0]
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "row col-sm-11 project-details"
    }, [_c('ul', {
      staticClass: "list-unstyled"
    }, [_c('li', [_vm._v(_vm._s(project.name))]), _vm._v(" "), _c('li', [_c('em', [_vm._v(_vm._s(project.company))])])])])])])
  })], 2), _vm._v(" "), _c('bootstrap-modal', {
    ref: "projectDetails",
    attrs: {
      "size": "large"
    }
  }, [_c('div', {
    attrs: {
      "slot": "title"
    },
    slot: "title"
  }, [_vm._v(_vm._s(_vm.projectDetails.name))]), _vm._v(" "), _c('div', {
    staticClass: "row",
    attrs: {
      "slot": "body"
    },
    slot: "body"
  }, [_c('div', {
    staticClass: "col-sm-12"
  }, [_c('div', {
    staticClass: "col-sm-offset-1 col-sm-10"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": _vm.projectDetails.images[0]
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-12"
  }, _vm._l((_vm.projectDetails.description), function(paragraph) {
    return _c('p', [_vm._v("\n            " + _vm._s(paragraph) + "\n          ")])
  })), _vm._v(" "), _c('div', {
    staticClass: "details col-sm-12"
  }, [_c('table', {
    staticClass: "table"
  }, [_c('tr', [_c('th', {
    staticClass: "col-xs-2"
  }, [_vm._v("Company:")]), _vm._v(" "), (_vm.projectDetails.company) ? _c('td', [_vm._v(_vm._s(_vm.projectDetails.company))]) : _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "col-xs-2"
  }, [_vm._v("Website:")]), _vm._v(" "), (_vm.projectDetails.website.url) ? _c('td', [_c('a', {
    attrs: {
      "href": _vm.projectDetails.website.url,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.projectDetails.website.name))])]) : _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "col-xs-2"
  }, [_vm._v("Programming languages:")]), _vm._v(" "), (_vm.projectDetails.language) ? _c('td', [_vm._v(_vm._s(_vm.projectDetails.language))]) : _c('td', [_vm._v("-")])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "col-xs-2"
  }, [_vm._v("Project Status:")]), _vm._v(" "), _c('td', [(_vm.projectDetails.finished) ? _c('span', [_vm._v("Finished")]) : _c('span', [_vm._v("In progress")])])]), _vm._v(" "), _c('tr', [_c('th', {
    staticClass: "col-xs-2"
  }, [_vm._v("Source Code:")]), _vm._v(" "), (_vm.projectDetails.sourceCode.url) ? _c('td', [_c('a', {
    attrs: {
      "href": _vm.projectDetails.sourceCode.url,
      "target": "_blank"
    }
  }, [_vm._v(_vm._s(_vm.projectDetails.sourceCode.name))])]) : _c('td', [_vm._v("-")])])])])]), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('button', {
    staticClass: "btn btn-default btn-md",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        _vm.$refs.projectDetails.close()
      }
    }
  }, [_vm._v("Close")])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "jumbotron"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('h1', [_vm._v("Projects")])])])
}]}

/***/ }),

/***/ 393:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(96);
module.exports = __webpack_require__(137);


/***/ })

},[393]);


// WEBPACK FOOTER //
// static/js/app.4dfc7856825145792289.js